<template>
  <CardSimple title="Short Circuit Outputs">
    <v-expansion-panels multiple>
      <v-expansion-panel v-for="element in outputObject" :key="element.title">
        <v-expansion-panel-header> {{ element.title }} </v-expansion-panel-header>
        <v-expansion-panel-content>
          <Table :headers="element.headers" :items="element.items" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </CardSimple>
</template>

<script>
export default {
  name: "ShortCircuitOutput",
  components: {
    CardSimple: () => import("@/components/CardSimple.vue"),
    Table: () => import("@/components/Table.vue"),
  },
  props: {
    caseOutputs: { type: Object, required: true },
    caseSettings: { type: Object, required: true },
  },
  data() {
    return {
      shortCircuitOutputMap: {
        bus: "Calculated Node Index",
        trafo: "Transformer Index",
        line: "Branch Index",
        ikss_ka: "Initial Symmetrical SC current (kA)",
        ith_ka: "Equivalent Thermal SC current (kA)",
        ip_ka: "SC Current Peak (kA)",
        ikss_hv_ka: "HV Side Initial Symmetrical SC current (kA)",
        ikss_lv_ka: "LV Side Initial Symmetrical SC current (kA)",
      },
    };
  },
  computed: {
    outputElements() {
      return Object.keys(this.caseOutputs.SHORT_CIRCUIT).filter(
        (el) => this.caseOutputs.SHORT_CIRCUIT[el].length
      );
    },
    outputObject() {
      const titles = { bus: "Nodes", line: "Branches", trafo: "Transformers" };
      return this.outputElements.map((el) => ({
        title: titles[el],
        items: this.formatFloatsInObject(el),
        headers: this.createHeaderObject(el),
      }));
    },
  },
  methods: {
    formatFloatsInObject(element) {
      return this.caseOutputs.SHORT_CIRCUIT[element].map((el) =>
        Object.fromEntries(
          Object.entries(el).map(([key, value]) => {
            const result = value.toFixed(!["index", "bus", "trafo", "line"].includes(key) ? 2 : 0);
            return [key, result];
          })
        )
      );
    },
    createHeaderObject(element) {
      const headers = Object.keys(this.caseOutputs.SHORT_CIRCUIT[element][0]).reduce((acc, v) => {
        if (this.shortCircuitOutputMap[v])
          acc.push({
            text: this.shortCircuitOutputMap[v],
            value: v,
          });
        return acc;
      }, []);
      if (!this.caseSettings.SHORT_CIRCUIT.return_all_currents || element === "bus") {
        headers.unshift({ text: "Index", value: "index" });
      }
      return headers;
    },
  },
  mounted() {},
  created() {},
};
</script>

<style></style>
